export default __webpack_public_path__ + "static/loupe-design-system-sheets-component-65d437fdfc76e1266b51fb9ceca45a1a.png";